import { animate } from "motion";

class Count {
    private observer: IntersectionObserver;
    private hasAnimated = false;

    constructor(private element: HTMLElement, private duration: number = 500) {
        this.observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting && !this.hasAnimated) {
                        this.start();
                        this.hasAnimated = true;
                        this.observer.disconnect();
                        break;
                    }
                }
            },
            { threshold: 0.4 }
        );

        this.observer.observe(this.element);
    }

    private start() {
        const targetValue = parseInt(this.element.innerText.replace(/,/g, ""), 10);
        if (isNaN(targetValue)) return;

        const proxy = { value: 0 };

        animate(
            proxy,
            { value: [0, targetValue] },
            ({
                duration: this.duration / 1000,
                easing: "easeOut",
                onUpdate: (latest: number) => {
                    this.element.innerText = `${Math.round(latest)}`;
                },
            } as any)
        );
    }
}


window.addEventListener("DOMContentLoaded", () => {
    const numberElements = document.querySelectorAll<HTMLElement>("[data-count]");
    numberElements?.forEach((number) => {
        new Count(number);
    });
})